const mutations = {
  RESET(state: StateObj) {
    state.sessionId = "";
  },
  UPDATE_SESSION(state: StateObj, sessionId: string) {
    state.sessionId = sessionId;
  }
};

export default mutations;
